require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-author-scott-hale-javier-soto.json") })
        }
      }, "path---blog-author-scott-hale-javier-soto");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-author-scott-hale-javier-soto!./.cache/json/blog-author-scott-hale-javier-soto.json
// module id = 706
// module chunks = 231608221292675